import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { NcSessionTokenService } from '../services/nc/nc-session-token.service';

/** When set, the staff auth interceptor must not override Authorization or refresh. */
export const NC_SESSION_AUTH_HEADER = 'X-Nc-Session-Auth';

function isNcSessionAuthorizedRequest(url: string): boolean {
  const lower = url.toLowerCase();
  return (
    (lower.includes('/api/episodes/') && lower.includes('/nc-encounter')) ||
    lower.includes('/api/nc/encounters/') ||
    lower.includes('/api/s3/')
  );
}

export const ncSessionAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(NcSessionTokenService);
  const token = session.token();
  if (!token || !isNcSessionAuthorizedRequest(req.url)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        [NC_SESSION_AUTH_HEADER]: '1'
      }
    })
  );
};
